import React from 'react';
import { StyledSpinner } from './Spinner.styles.mjs';

const Spinner = ({ size = '32px' }) => {
    return React.createElement(StyledSpinner, { size: size });
};

export { Spinner as default };
//# sourceMappingURL=Spinner.mjs.map
